import { Readable, readable, Updater, writable, Writable } from './store';

export interface StoredWritable<T> extends Writable<T> {
  isDefault: () => boolean;
}

export function locallyStoredWritable<T>(name: string, value?: T) {
  return dynamicStoredWritable(readable(name), value);
}

export function dynamicStoredWritable<T>(nameStore: Readable<string>, defaultValue?: T) {
  let name: string;

  const {
    get,
    set: origSet,
    subscribe,
  } = writable<T>(defaultValue, set => {
    return nameStore.subscribe(nameValue => {
      name = nameValue;
      try {
        const stored = localStorage.getItem(name);
        if (stored) {
          set(JSON.parse(stored));
          return;
        }
      } catch (err) {
        try {
          const stored = localStorage.getItem(name);
          if (stored) {
            set(stored as unknown as T);
            return;
          }
        } catch (err) {}
      }
      set(defaultValue);
    });
  });

  function set(value: T) {
    if (value == null || value === defaultValue) {
      localStorage.removeItem(name);
    } else {
      localStorage[name] = typeof value === 'string' ? value : JSON.stringify(value);
    }
    return origSet(value == null ? defaultValue : value);
  }

  function update(fn: Updater<T>): Promise<void> {
    return set(fn(defaultValue));
  }

  function isDefault() {
    return get() === defaultValue;
  }

  return {
    isDefault,
    get,
    set,
    update,
    subscribe,
  };
}
